import React from "react";
import { StyleSheet, View } from "react-native";

import { LineChart } from "react-native-svg-charts";
import * as shape from "d3-shape";

export default function ReflectionItemChart({ timeline = { hours: [] } }) {
  const contentInset = {
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
  };

  let hmin = 0;
  let hmax = 0;
  const max_ticks = 12;
  const values = timeline.hours
    .slice(
      Math.max(timeline.hours.length - max_ticks, 0),
      Math.max(timeline.hours.length - 1, 0),
    )
    .map((d) => {
      if (d < hmin) hmin = d;
      if (d > hmax) hmax = d;
      return parseFloat(d);
    });

  const ticks = Math.min(max_ticks, values.length);

  //TODO: add a point with the current number of hours?
  return (
    <View style={styles.container}>
      <LineChart
        style={styles.chart}
        data={values}
        contentInset={contentInset}
        curve={shape.curveLinear}
        svg={{ strokeWidth: 1, stroke: "#0c0c0c" }}
        numberOfTicks={ticks}
        gridMin={hmin}
        gridMax={hmax}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: 75,
    height: 52,
    maxHeight: "100%",
    justifyContent: "center",
    alignItems: "center",
    marginLeft: "auto",
    marginRight: 10,
  },
  chart: {
    height: "50%",
    width: "100%",
    overflow: "hidden",
  },
});
